import { LEGEND_SET_ITEMS } from './legend.actions';
import { produce } from 'immer';
import { ILegendState, LegendActions, MapLegendItem } from './legend.types';

const legendInitialState: ILegendState = {
	legends: {}
};

export function legendReducer(
	state: ILegendState = legendInitialState,
	action: LegendActions
): ILegendState {
	switch (action.type) {
		case LEGEND_SET_ITEMS:
			return setLegendItems(
				state,
				action.mapId,
				action.payload as MapLegendItem[]
			);
		default:
			return state;
	}
}

function setLegendItems(
	currentState: ILegendState,
	mapId: string,
	items: MapLegendItem[]
): ILegendState {
	return produce(currentState, (draftState: ILegendState) => {
		draftState.legends[mapId] = items;
	});
}
